<script lang="ts" setup>
import { inject } from 'vue';

import type { Ref } from 'vue';
import type { IManifestHotspot } from '@/types/IManifest';

const hotspot = inject('hotspot') as Ref<IManifestHotspot>;
</script>

<template>
  <div class="flex flex-col mt-2">
    <label class="text-xs">Flat Content URL</label>
    <input v-model="hotspot.flatContentURL" class="border px-1 py-0.5 text-xs" type="text">
  </div>
</template>
